
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class SectionAttendanceForm extends Form {
	private static _instance = new SectionAttendanceForm();
	subjectRegisterId:Field = {
		name:'subjectRegisterId'
		,controlType: 'Hidden'
		,label: 'subjectRegisterId'
		,isRequired: true
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};
	studentId:Field = {
		name:'studentId'
		,controlType: 'Hidden'
		,label: 'studentId'
		,valueType: 1
		,defaultValue: 0
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};
	name:Field = {
		name:'name'
		,controlType: 'Output'
		,label: 'name'
		,valueType: 0
		,errorId: 'invalidName'
		,maxLength: 150
	};
	usn:Field = {
		name:'usn'
		,controlType: 'Output'
		,label: 'usn'
		,valueType: 0
		,errorId: 'invalidText'
		,maxLength: 1000
	};
	tempUsn:Field = {
		name:'tempUsn'
		,controlType: 'Output'
		,label: 'tempUsn'
		,valueType: 0
		,errorId: 'invalidText'
		,maxLength: 1000
	};
	totalAttendance:Field = {
		name:'totalAttendance'
		,controlType: 'Output'
		,label: 'totalAttendance'
		,valueType: 1
		,defaultValue: 0
		,errorId: 'invalidInteger'
		,maxValue: 9999999999999
	};
	hasWithdrawn:Field = {
		name:'hasWithdrawn'
		,controlType: 'Output'
		,label: 'hasWithdrawn'
		,valueType: 3
		,errorId: 'invalidBool'
	};
	overallAttendance:Field = {
		name:'overallAttendance'
		,controlType: 'Output'
		,label: 'overallAttendance'
		,valueType: 0
		,defaultValue: ''
		,errorId: 'invalidText'
		,maxLength: 1000
	};

	public static getInstance(): SectionAttendanceForm {
		return SectionAttendanceForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.controls.set('subjectRegisterId', [Validators.required, Validators.max(9999999999999)]);
		this.fields.set('subjectRegisterId', this.subjectRegisterId);
		this.controls.set('studentId', [Validators.max(9999999999999)]);
		this.fields.set('studentId', this.studentId);
		this.controls.set('name', [Validators.maxLength(150)]);
		this.fields.set('name', this.name);
		this.controls.set('usn', [Validators.maxLength(1000)]);
		this.fields.set('usn', this.usn);
		this.controls.set('tempUsn', [Validators.maxLength(1000)]);
		this.fields.set('tempUsn', this.tempUsn);
		this.controls.set('totalAttendance', [Validators.max(9999999999999)]);
		this.fields.set('totalAttendance', this.totalAttendance);
		this.controls.set('hasWithdrawn', []);
		this.fields.set('hasWithdrawn', this.hasWithdrawn);
		this.controls.set('overallAttendance', [Validators.maxLength(1000)]);
		this.fields.set('overallAttendance', this.overallAttendance);
		this.opsAllowed = {filter: true};
		this.keyFields = ["subjectRegisterId"];
	}

	public getName(): string {
		 return 'sectionAttendance';
	}
}


export class SectionAttendanceFd extends FormData {
	constructor(form: SectionAttendanceForm, sa: ServiceAgent) {
		super(form, sa);
	}

	setFieldValue(name: 'subjectRegisterId' | 'studentId' | 'name' | 'usn' | 'tempUsn' | 'totalAttendance' | 'hasWithdrawn' | 'overallAttendance', value: string | number | boolean | null ): void {
		super.setFieldValue(name, value);
	}

	getFieldValue(name: 'subjectRegisterId' | 'studentId' | 'name' | 'usn' | 'tempUsn' | 'totalAttendance' | 'hasWithdrawn' | 'overallAttendance' ): string | number | boolean | null {
		return super.getFieldValue(name);
	}
}


export interface SectionAttendanceVo extends Vo {
	studentId?: number, 
	usn?: string, 
	overallAttendance?: string, 
	totalClasses?: number, 
	subjectRegisterId?: number, 
	hasWithdrawn?: boolean, 
	subjectSectionId?: number, 
	totalAttendance?: number, 
	name?: string, 
	instituteId?: number, 
	tempUsn?: string
}
